// extracted by mini-css-extract-plugin
export default {"container":"Table_container__edCc8","buttonContainer":"Table_buttonContainer__3YNa8"};